<template>
  <div class="gif-wrapper">
    <div class="search-box">
      <SearchIcon /> <input v-model="searchQuery" placeholder="Search tenor">
    </div>
    <div v-if="searchResults.length > 0" ref="gifContainer" class="gif-container">
      <div>
        <img
          v-for="gif in searchResultsColumns[0]" :key="gif.id" :src="gif.media_formats.gif.url"
          :alt="gif.content_desctiption" @click="addGif(gif.media_formats.gif.url, gif.content_desctiption)"
        >
      </div>
      <div>
        <img
          v-for="gif in searchResultsColumns[1]" :key="gif.id" :src="gif.media_formats.gif.url"
          :alt="gif.content_desctiption" @click="addGif(gif.media_formats.gif.url, gif.content_desctiption)"
        >
      </div>
    </div>
    <div v-else ref="gifContainer" class="gif-container">
      <div>
        <img
          v-for="gif in trendingGifsColumns[0]" :key="gif.id" :src="gif.media_formats.gif.url"
          :alt="gif.content_desctiption" @click="addGif(gif.media_formats.gif.url, gif.content_desctiption)"
        >
      </div>
      <div>
        <img
          v-for="gif in trendingGifsColumns[1]" :key="gif.id" :src="gif.media_formats.gif.url"
          :alt="gif.content_desctiption" @click="addGif(gif.media_formats.gif.url, gif.content_desctiption)"
        >
      </div>
    </div>
  </div>
</template>

<script>
import { debounce } from 'lodash-es';
import SearchIcon from '../assets/svg/icon-search-gif.svg?vue-component';

export default {
  components: {
    SearchIcon,
  },
  data() {
    return {
      trendingGifs: [],
      searchResults: [],
      searchQuery: '',
      nextPos: '',
      isLoading: false,
    };
  },
  computed: {
    searchResultsColumns() {
      return [
        this.searchResults.filter((_, index) => index % 2 === 0),
        this.searchResults.filter((_, index) => index % 2 !== 0),
      ];
    },
    trendingGifsColumns() {
      return [
        this.trendingGifs.filter((_, index) => index % 2 === 0),
        this.trendingGifs.filter((_, index) => index % 2 !== 0),
      ];
    },
  },
  watch: {
    searchQuery: debounce(function data(newQuery, oldQuery) {
      if (newQuery !== oldQuery) {
        this.nextPos = '';
        this.searchResults = [];
        this.searchGifs();
      }
    }, 500),
  },
  mounted() {
    this.getTrendingGifs();

    this.$root.$on('clear-gif-search', () => {
      this.searchResults = [];
      this.searchQuery = '';
      this.nextPos = '';
      this.isLoading = false;
    });

    const { gifContainer } = this.$refs;
    gifContainer.addEventListener('scroll', this.handleScroll);
  },
  methods: {
    async getTrendingGifs() {
      const response = await this.$axios.$get('/tenor/trending', { progress: false });

      this.trendingGifs = response.results;
    },
    async searchGifs(loadMore = false) {
      if (!this.searchQuery || this.isLoading) return;
      this.isLoading = true;

      try {
        const params = { query: this.searchQuery };
        if (loadMore && this.nextPos) {
          params.pos = this.nextPos;
        }

        const response = await this.$axios.$get('tenor/search', { params, progress: false });

        if (loadMore) {
          this.searchResults = [...this.searchResults, ...response.results];
        } else {
          this.searchResults = response.results;
        }

        this.nextPos = response.next || '';
      } catch (error) {
        console.error('Error searching GIFs:', error);
      } finally {
        this.isLoading = false;
      }
    },

    handleScroll(event) {
      const container = event.target;
      const scrollPosition = container.scrollTop + container.clientHeight;
      const threshold = container.scrollHeight - 200;

      if (scrollPosition >= threshold && this.nextPos && !this.isLoading) {
        this.searchGifs(true);
      }
    },

    addGif(url, description) {
      this.$root.$emit('add-gif', url, description);
    },
  },
};
</script>
